
































import Vue from 'vue';

export default Vue.extend({
  model: {
    event: `change`,
    prop: `value`,
  },
  props: {
    centered: {
      default: false,
      type: Boolean,
    },
    customI18nextContent: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    label: {
      default: ``,
      type: String,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    testSelectorIndex: {
      default: ``,
      type: String,
    },
    value: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    onCheckBoxChanged(value: boolean): void {
      this.$emit(`change`, value);
    },
  },
});
